import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';
import scientistError from 'lottie/scientist_error.json';

const CampaignErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-block-start: 20px;
  flex: 1 1 auto;
`;
const CampaignError = () => {
  return (
    <CampaignErrorContainer>
      <Player autoplay loop src={scientistError} style={{ height: '300px', width: '300px' }}></Player>
      <Typography.Heading6>
        <FormattedMessage id="campaigns.error-unknown" />
      </Typography.Heading6>
      <Typography.Body3>
        <FormattedMessage id="campaigns.error-fetch" />
      </Typography.Body3>
    </CampaignErrorContainer>
  );
};

export default CampaignError;
